export function normalizeUrl(url: string) {
  return url.endsWith('/') ? url.slice(0, -1) : url;
}
